import { ClaimReasonDTO } from "../dto/claim_reason.dto";

export const claim_brand_reasons: ClaimReasonDTO[] = [
    // VISA
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Cambio de responsabilidad del Chip - Fraude por falsificación",
    "code": "10.1",
    "dispute_reason": "EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Cambio de responsabilidad del Chip - Fraude no relacionado con falsificación",
    "code": "10.2",
    "dispute_reason": "EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta presente - Tarjeta Perdida",
    "code": "10.3.1",
    "dispute_reason": "NOT_AUTHORIZED_CARD_PRESENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta presente - Tarjeta Robada",
    "code": "10.3.2",
    "dispute_reason": "NOT_AUTHORIZED_CARD_PRESENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta presente - Not Received as Issued (NRI)",
    "code": "10.3.3",
    "dispute_reason": "NOT_AUTHORIZED_CARD_PRESENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta presente - Aplicación Fraudulenta",
    "code": "10.3.4",
    "dispute_reason": "NOT_AUTHORIZED_CARD_PRESENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta presente - Tarjeta Clonada o Falsificada",
    "code": "10.3.5",
    "dispute_reason": "NOT_AUTHORIZED_CARD_PRESENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta presente - Misceláneo",
    "code": "10.3.6",
    "dispute_reason": "NOT_AUTHORIZED_CARD_PRESENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta presente - Toma de Control de Cuenta o Credenciales",
    "code": "10.3.7",
    "dispute_reason": "NOT_AUTHORIZED_CARD_PRESENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta presente - Engaño del Comerciante",
    "code": "10.3.8",
    "dispute_reason": "NOT_AUTHORIZED_CARD_PRESENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta presente - Manipulación del Titular de la Cuenta",
    "code": "10.3.9",
    "dispute_reason": "NOT_AUTHORIZED_CARD_PRESENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta no presente - Aplicación Fraudulenta",
    "code": "10.4.1",
    "dispute_reason": "NOT_AUTHORIZED_CARD_ABSENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta no presente - Misceláneo",
    "code": "10.4.2",
    "dispute_reason": "NOT_AUTHORIZED_CARD_ABSENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta no presente - Uso Fraudulento del Número de Tarjeta",
    "code": "10.4.3",
    "dispute_reason": "NOT_AUTHORIZED_CARD_ABSENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta no presente - Toma de Control de Cuenta o Credenciales",
    "code": "10.4.4",
    "dispute_reason": "NOT_AUTHORIZED_CARD_ABSENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta no presente - Engaño del Comerciante",
    "code": "10.4.5",
    "dispute_reason": "NOT_AUTHORIZED_CARD_ABSENT",
    "need_file": false
  },
  {
    "network": "VISA",
    "category": "1 - Disputas de Fraude",
    "reason": "Fraude - Tarjeta no presente - Manipulación del Titular de la Cuenta",
    "code": "10.4.6",
    "dispute_reason": "NOT_AUTHORIZED_CARD_ABSENT",
    "need_file": false
  },
  {
      network: "VISA",
      category: "2 - Relacionados con autorizaciones",
      reason: "Boletín de Tarjetas canceladas",
      code: "11.1",
      dispute_reason: "CANCELED_CARDS_BULLETIN",
      need_file: false
    },
    {
      network: "VISA",
      category: "2 - Relacionados con autorizaciones",
      reason: "Autorización denegada",
      code: "11.2",
      dispute_reason: "AUTHORIZATION_DENIED",
      need_file: false
    },
    {
      network: "VISA",
      category: "2 - Relacionados con autorizaciones",
      reason: "Sin autorización",
      code: "11.3",
      dispute_reason: "NO_AUTHORIZATION",
      need_file: false
    },
    {
      network: "VISA",
      category: "3 - Errores en el POI",
      reason: "Presentación tardía",
      code: "12.1",
      dispute_reason: "LATE_PRESENTMENT",
      need_file: false
    },
    {
      network: "VISA",
      category: "3 - Errores en el POI",
      reason: "Código de transacción incorrecto",
      code: "12.2",
      dispute_reason: "INCORRECT_TRANSACTION_CODE",
      need_file: false
    },
    {
      network: "VISA",
      category: "3 - Errores en el POI",
      reason: "Moneda incorrecta",
      code: "12.3",
      dispute_reason: "INCORRECT_CURRENCY",
      need_file: true
    },
    {
      network: "VISA",
      category: "3 - Errores en el POI",
      reason: "Cuenta incorrecta",
      code: "12.4",
      dispute_reason: "INCORRECT_ACCOUNT_NUMBER",
      need_file: true
    },
    {
      network: "VISA",
      category: "3 - Errores en el POI",
      reason: "Monto incorrecto",
      code: "12.5",
      dispute_reason: "INCORRECT_TRANSACTION_AMOUNT",
      need_file: true
    },
    {
      network: "VISA",
      category: "3 - Errores en el POI",
      reason: "Multiplicidad",
      code: "12.6",
      dispute_reason: "DUPLICATE",
      need_file: true
    },
    {
      network: "VISA",
      category: "3 - Errores en el POI",
      reason: "Pago por otros medios",
      code: "12.6",
      dispute_reason: "PAYMENT_BY_OTHER",
      need_file: true
    },
    {
      network: "VISA",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "No se recibió mercancía/ servicio",
      code: "13.1",
      dispute_reason: "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED",
      need_file: true
    },
    {
      network: "VISA",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "Transacción recurrente cancelada",
      code: "13.2",
      dispute_reason: "CANCELLED_RECURRING_TRANSACTION",
      need_file: true
    },
    {
      network: "VISA",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "No es lo descrito o mercancía/ servicio defectuoso",
      code: "13.3",
      dispute_reason: "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE",
      need_file: true
    },
    {
      network: "VISA",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "Mercancía falsificada",
      code: "13.4",
      dispute_reason: "COUNTERFEIT_MERCHANDISE",
      need_file: true
    },
    {
      network: "VISA",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "Declaraciones engañosas",
      code: "13.5",
      dispute_reason: "MISLEADING_STATEMENTS",
      need_file: true
    },
    {
      network: "VISA",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "Crédito no procesado",
      code: "13.6",
      dispute_reason: "CREDIT_NOT_PROCESSED",
      need_file: true
    },
    {
      network: "VISA",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "Mercancía/ servicio cancelado",
      code: "13.7",
      dispute_reason: "CANCELLED_MERCHANDISE_OR_SERVICES",
      need_file: true
    },
    {
      network: "VISA",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "No se recibió el efectivo o valor de transacción de carga",
      code: "13.9",
      dispute_reason: "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM",
      need_file: false
    },
  
    // MASTERCARD
    {
      network: "MASTERCARD",
      category: "1 - Disputas de Fraude",
      reason: "Sin autorización del TH",
      code: "4837",
      dispute_reason: "NOT_AUTHORIZED_CARD_PRESENT",
      need_file: false
    },
    {
      network: "MASTERCARD",
      category: "1 - Disputas de Fraude",
      reason: "Actividad sospechosa del comercio",
      code: "4849",
      dispute_reason: null,
      need_file: false
    },
    {
      network: "MASTERCARD",
      category: "1 - Disputas de Fraude",
      reason: "Cambio de Responsabilidad del Chip",
      code: "4870",
      dispute_reason: "EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD",
      need_file: false
    },
    {
      network: "MASTERCARD",
      category: "1 - Disputas de Fraude",
      reason: "Cambio de Responsabilidad del Chip - Fraude por tarjeta extraviada/ robada/ emitida nunca recibida (NRI)",
      code: "4871",
      dispute_reason: "EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD",
      need_file: false
    },
    {
      network: "MASTERCARD",
      category: "2 - Relacionados con autorizaciones",
      reason: "Autorización denegada",
      code: "4808",
      dispute_reason: "AUTHORIZATION_DENIED",
      need_file: false
    },
    {
      network: "MASTERCARD",
      category: "2 - Relacionados con autorizaciones",
      reason: "Sin autorización",
      code: null,
      dispute_reason: "NO_AUTHORIZATION",
      need_file: false
    },
    {
      network: "MASTERCARD",
      category: "3 - Errores en el POI",
      reason: "Presentación tardía",
      code: "4834",
      dispute_reason: "LATE_PRESENTMENT",
      need_file: false
    },
    {
      network: "MASTERCARD",
      category: "3 - Errores en el POI",
      reason: "Código de transacción incorrecto",
      code: null,
      dispute_reason: "INCORRECT_TRANSACTION_CODE",
      need_file: false
    },
    {
      network: "MASTERCARD",
      category: "3 - Errores en el POI",
      reason: "Moneda incorrecta",
      code: null,
      dispute_reason: "INCORRECT_CURRENCY",
      need_file: true
    },
    {
      network: "MASTERCARD",
      category: "3 - Errores en el POI",
      reason: "Cuenta incorrecta",
      code: null,
      dispute_reason: "INCORRECT_ACCOUNT_NUMBER",
      need_file: true
    },
    {
      network: "MASTERCARD",
      category: "3 - Errores en el POI",
      reason: "Monto incorrecto",
      code: null,
      dispute_reason: "INCORRECT_TRANSACTION_AMOUNT",
      need_file: true
    },
    {
      network: "MASTERCARD",
      category: "3 - Errores en el POI",
      reason: "Multiplicidad",
      code: null,
      dispute_reason: "DUPLICATE",
      need_file: true
    },
    {
      network: "MASTERCARD",
      category: "3 - Errores en el POI",
      reason: "Pago por otros medios",
      code: null,
      dispute_reason: "PAYMENT_BY_OTHER",
      need_file: true
    },
    {
      network: "MASTERCARD",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "No se recibió mercancía/ servicio",
      code: "4853",
      dispute_reason: "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED",
      need_file: true
    },
    {
      network: "MASTERCARD",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "Transacción recurrente cancelada",
      code: null,
      dispute_reason: "CANCELLED_RECURRING_TRANSACTION",
      need_file: true
    },
    {
      network: "MASTERCARD",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "No es lo descrito o mercancía/ servicio defectuoso",
      code: null,
      dispute_reason: "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE",
      need_file: true
    },
    {
      network: "MASTERCARD",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "Mercancía falsificada",
      code: null,
      dispute_reason: "COUNTERFEIT_MERCHANDISE",
      need_file: true
    },
    {
      network: "MASTERCARD",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "Declaraciones engañosas",
      code: null,
      dispute_reason: "MISLEADING_STATEMENTS",
      need_file: true
    },
    {
      network: "MASTERCARD",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "Crédito no procesado",
      code: null,
      dispute_reason: "CREDIT_NOT_PROCESSED",
      need_file: true
    },
    {
      network: "MASTERCARD",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "Mercancía/ servicio cancelado",
      code: null,
      dispute_reason: "CANCELLED_MERCHANDISE_OR_SERVICES",
      need_file: true
    },
    {
      network: "MASTERCARD",
      category: "4 - Disputas del Tarjetahabiente",
      reason: "No se recibió el efectivo o valor de transacción de carga",
      code: null,
      dispute_reason: "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM",
      need_file: false
    }
  ];
  